import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataTransfer = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 10 10" {...props}>
    <path
      fill="#8B7D96"
      d="m2.499 1.91-.95.95q-.15.15-.35.145a.5.5 0 0 1-.35-.157.53.53 0 0 1-.144-.35.46.46 0 0 1 .144-.35l1.8-1.8a.44.44 0 0 1 .162-.106A.6.6 0 0 1 3 .211q.101 0 .187.031.088.031.163.106l1.8 1.8a.47.47 0 0 1 .137.344.5.5 0 0 1-.137.356q-.15.15-.356.15a.49.49 0 0 1-.357-.15L3.5 1.911v7.087q0 .212-.144.357A.48.48 0 0 1 3 9.498a.48.48 0 0 1-.356-.143.48.48 0 0 1-.144-.357zm4 6.176V.998q0-.212.144-.356a.48.48 0 0 1 .356-.144q.213 0 .356.144A.48.48 0 0 1 7.5.998v7.088l.95-.95q.15-.15.35-.144t.35.156q.138.15.144.35a.46.46 0 0 1-.144.35l-1.8 1.8a.44.44 0 0 1-.163.107.6.6 0 0 1-.187.03.6.6 0 0 1-.188-.03.44.44 0 0 1-.162-.107l-1.8-1.8a.47.47 0 0 1-.138-.343.5.5 0 0 1 .138-.357q.15-.15.356-.15.207 0 .356.15z"
    />
  </svg>
);
export default SvgDataTransfer;
